import { render, staticRenderFns } from "./Sustainable.vue?vue&type=template&id=6aa5630b&scoped=true&"
import script from "./Sustainable.vue?vue&type=script&lang=js&"
export * from "./Sustainable.vue?vue&type=script&lang=js&"
import style0 from "./Sustainable.vue?vue&type=style&index=0&id=6aa5630b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5630b",
  null
  
)

export default component.exports